export const ru = {
  app: { name: "Поехали" },
  nav: { chats: "Чаты", contacts: "Контакты", orders: "Заказы", profile: "Профиль" },
  stub: { soon: "Скоро", chatsDesc: "Чаты появятся в следующем обновлении", ordersDesc: "Заказы появятся в следующем обновлении" },
  chats: {
    global: "Общий чат",
    members: "все участники сообщества",
    you: "Вы",
    noMessages: "Нет сообщений — напишите первым!",
    inputPlaceholder: "Сообщение…",
    typing: "печатает…",
    online: "в сети",
    offline: "не в сети",
    write: "Написать",
    sending: "Отправка…",
    failed: "Не отправлено",
    retry: "Повторить",
    photo: "📷 Фото",
    attach: "Прикрепить фото",
    caption: "Подпись к фото…",
    photoLimit: "Допустимы JPEG, PNG и WebP до 5 МБ",
    photoLoading: "Загрузка фото…",
    photoFailed: "Не удалось загрузить фото",
    photoUnavailable: "Фото удалено или недоступно",
    uploadProgress: (n) => `Загрузка: ${n}%`,
    processing: "Создаём миниатюру и отправляем…",
    reply: "Ответить",
    edit: "Редактировать",
    editing: "Редактирование сообщения",
    edited: "изменено",
    delete: "Удалить",
    deleteConfirm: "Удалить сообщение у всех участников?",
    deleted: "Сообщение удалено",
    actions: "Действия с сообщением",
    close: "Закрыть",
    save: "Сохранить",
    send: "Отправить",
    cancel: "Отмена",
    read: "Прочитано",
    delivered: "Доставлено на сервер",
    search: "Поиск сообщений и подписей",
    searchButton: "Найти",
    noResults: "Ничего не найдено",
    originalMissing: "Исходное сообщение не найдено",
    zoomIn: "Увеличить",
    zoomOut: "Уменьшить",
    viewerHint: "Сведите пальцы для масштаба · смахните вниз, чтобы закрыть",
  },
  auth: {
    loginTitle: "Вход",
    registerTitle: "Регистрация",
    phone: "Номер телефона",
    phonePlaceholder: "+7 900 000-00-00",
    password: "Пароль",
    passwordPlaceholder: "Минимум 6 символов",
    name: "Имя",
    namePlaceholder: "Как вас зовут",
    inviteCode: "Инвайт-код",
    invitePlaceholder: "Код приглашения",
    loginBtn: "Войти",
    registerBtn: "Зарегистрироваться",
    noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    toRegister: "Регистрация",
    toLogin: "Войти",
    inviteOnly: "Регистрация по приглашению",
    openRegistration: "Создайте аккаунт за минуту",
    loggedOut: "Вы вышли из аккаунта",
  },
  profile: {
    title: "Профиль",
    edit: "Редактировать",
    save: "Сохранить",
    cancel: "Отмена",
    logout: "Выйти",
    changeAvatar: "Изменить фото",
    saved: "Сохранено",
    avatarUpdated: "Фото обновлено",
    driverSection: "Автомобиль",
    carModel: "Марка и модель",
    carColor: "Цвет",
    carPlate: "Госномер",
    memberSince: "В приложении с",
    userNotFound: "Пользователь не найден",
  },
  roles: {
    passenger: "Пассажир",
    driver: "Водитель",
    admin: "Администратор",
    banned: "Заблокирован",
  },
  invites: {
    title: "Приглашения",
    create: "Создать инвайт",
    empty: "У вас пока нет приглашений",
    copy: "Копировать ссылку",
    copied: "Ссылка скопирована",
    used: "Использован",
    unused: "Активен",
    usedBy: "Использовал(а):",
    maxUses: "Лимит использований",
  },
  admin: {
    title: "Админ-панель",
    searchPlaceholder: "Поиск по телефону или имени",
    driverToggle: "Водитель",
    ban: "Заблокировать",
    unban: "Разблокировать",
    empty: "Пользователи не найдены",
    multiInvite: "Многоразовый инвайт",
    createMultiInvite: "Создать",
    invitesCreated: "Инвайт создан",
  },
  errors: {
    generic: "Что-то пошло не так. Попробуйте ещё раз.",
    network: "Ошибка сети",
  },
  orders: {
    loading: "Загрузка заказа…",
    unavailable: "Заказ недоступен",
    loadFailed: "Не удалось загрузить заказ",
    new: "Новый",
    myOrder: "Ваш заказ",
    pickup: "Откуда",
    destination: "Куда (необязательно)",
    comment: "Комментарий (необязательно)",
    publish: "Опубликовать заказ",
    created: "Заказ опубликован",
    accept: "Принять",
    complete: "Завершить",
    release: "Отказаться",
    cancel: "Отменить",
    write: "Написать",
    history: "История",
    loadMore: "Показать ещё",
    emptyOpen: "Открытых заказов нет",
    emptyMine: "У вас нет принятых заказов",
    emptyHistory: "История пуста",
    tabs: { open: "Открытые", mine: "Мои активные" },
    status: {
      open: "Открыт",
      accepted: "Принят",
      completed: "Завершён",
      cancelled: "Отменён",
    },
    reason: {
      by_passenger: "пассажиром",
      by_driver: "водителем",
      timeout: "по таймауту",
    },
    actionDone: {
      accept: "Вы приняли заказ",
      complete: "Заказ завершён",
      release: "Вы отказались от заказа",
      cancel: "Заказ отменён",
    },
    notice: {
      accepted: "Ваш заказ принят",
      released: "Водитель отказался от заказа",
      completed: "Заказ завершён",
      cancelled: "Заказ отменён пассажиром",
      timeout: "Заказ отменён: никто не принял за 30 минут",
    },
  },
  calls: {
    title: "Звонки",
    call: "Позвонить",
    videoCall: "Видеозвонок",
    incoming: "Входящий звонок",
    incomingVideo: "Входящий видеозвонок",
    mediaDenied: "Разрешите доступ к камере и микрофону",
    cameraFallback: "Камера недоступна — продолжаем без видео",
    switchUnavailable: "Вторая камера недоступна",
    soundTitle: "Звук звонка",
    soundDesc: "Мелодия и вибрация на этом устройстве",
    soundOn: "Звук звонка включён",
    soundOff: "Звук звонка отключён",
    notMutual: "Видеозвонки доступны только взаимным контактам",
    calling: "Вызов…",
    empty: "Звонков пока нет",
    unknown: "Неизвестный",
    micDenied: "Разрешите доступ к микрофону",
    noConnection: "Нет связи с сервером. Попробуйте позже.",
    busy: "Абонент занят",
    declinedByPeer: "Вызов отклонён",
    missed: "Звонок не отвечен",
    connectionLost: "Связь потеряна",
    failed: "Не удалось установить соединение",
    notAllowed: "Звонить можно только собеседнику из чата или по активному заказу",
    p2pNote: "Звонок идёт напрямую между устройствами",
    status: {
      ringing: "Вызов",
      active: "В разговоре",
      ended: "Завершён",
      declined: "Отклонён",
      missed: "Пропущен",
      busy: "Занято",
      failed: "Сбой связи",
    },
  },
  contacts: {
    title: "Контакты",
    mine: "Мои контакты",
    suggested: "Возможно вы знакомы",
    add: "Добавить",
    added: "Добавлено в контакты",
    removed: "Удалено из контактов",
    remove: "Удалить",
    write: "Написать",
    call: "Позвонить",
    emptyTitle: "Пока никого нет",
    emptyDesc: "Найдите друзей из телефонной книги или пригласите их по личной ссылке — регистрация займёт минуту.",
    findFriends: "Найти друзей из телефонной книги",
    findFriendsDesc: "Мы сверим номера и покажем, кто уже в «Поехали». Номера не сохраняются.",
    inviteTitle: "Пригласить в «Поехали»",
    inviteDesc: "Отправьте личную ссылку — приглашённые попадут в ваш список",
    shareBtn: "Поделиться ссылкой",
    shareText: "Присоединяйся к «Поехали» — заказы поездок и чат сообщества",
    linkCopied: "Ссылка скопирована",
    matchTitle: "Уже в «Поехали»",
    matchNone: "Из выбранных номеров пока никого нет в приложении",
    matchRest: (n) => `Ещё ${n} из книжки не в приложении — пригласите их по ссылке`,
    pickerError: "Не удалось открыть телефонную книгу",
    inContacts: "В контактах",
    search: "Найти по имени",
    searchButton: "Найти",
    searchMin: "Введите минимум 2 символа",
    searching: "Ищем людей…",
    searchEmpty: "Пользователи не найдены",
    searchResults: "Результаты поиска",
  },
  pwa: {
    installForPush: "Установите приложение на экран „Домой“, чтобы получать уведомления",
    promptDismissed: "Уведомления можно включить позже в профиле",
    installTitle: "Установить приложение",
    installDesc: "Быстрый доступ с домашнего экрана",
    install: "Установить",
    iosHint: "Поделиться → На экран «Домой»",
    pushTitle: "Push-уведомления",
    pushDesc: "На этом устройстве",
    promptText: "Включите уведомления, чтобы не пропускать заказы и звонки",
    promptAllow: "Включить",
    promptLater: "Позже",
    stateNotAsked: "Разрешение ещё не запрошено",
    stateDenied: "Уведомления запрещены в браузере",
    stateGrantedNoSub: "Разрешено, но подписки на этом устройстве нет",
    stateOn: (n) => `Включены · устройств с подпиской: ${n}`,
    deniedHint: "Вернитесь в приложение после изменения разрешения — подписка включится автоматически.",
    instructions: "Как включить",
    deniedChrome: "Замочек в адресной строке → Уведомления → Разрешить",
    deniedAndroid: "Настройки телефона → Приложения → Поехали → Уведомления",
    deniedIOS: "Настройки → Уведомления → Поехали",
    chromeInstallHint: "Меню Chrome → Установить приложение",
    instructionClose: "Понятно",
    serverOff: "Сервер уведомлений не настроен — push временно недоступен",
    pushOn: "Уведомления включены",
    pushOff: "Уведомления отключены",
    pushDenied: "Разрешите уведомления в настройках браузера",
  },
};
